import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquarePollVertical = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.5 3.5V18.5C0.5 20.1875 1.8125 21.5 3.5 21.5H18.5C20.1406 21.5 21.5 20.1875 21.5 18.5V3.5C21.5 1.85938 20.1406 0.5 18.5 0.5H3.5C1.8125 0.5 0.5 1.85938 0.5 3.5ZM18.5 2C19.2969 2 20 2.70312 20 3.5V18.5C20 19.3438 19.2969 20 18.5 20H3.5C2.65625 20 2 19.3438 2 18.5V3.5C2 2.70312 2.65625 2 3.5 2H18.5ZM7.25 16.25V10.25C7.25 9.875 6.875 9.5 6.5 9.5C6.07812 9.5 5.75 9.875 5.75 10.25V16.25C5.75 16.6719 6.07812 17 6.5 17C6.875 17 7.25 16.6719 7.25 16.25ZM10.25 5.75V16.25C10.25 16.6719 10.5781 17 11 17C11.375 17 11.75 16.6719 11.75 16.25V5.75C11.75 5.375 11.375 5 11 5C10.5781 5 10.25 5.375 10.25 5.75ZM14.75 13.25V16.25C14.75 16.6719 15.0781 17 15.5 17C15.875 17 16.25 16.6719 16.25 16.25V13.25C16.25 12.875 15.875 12.5 15.5 12.5C15.0781 12.5 14.75 12.875 14.75 13.25Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgSquarePollVertical);
export { ForwardRef as ReactComponent };
